import { useCallback, useMemo } from 'react';
import { ExpandedNodesMap, Node, FlatTreeNode } from '../';

export function useGetFlatTreeNodeList(nodes: Node[], expandedNodes: ExpandedNodesMap) {
  const collectNodeInfo = useCallback(
    (node: FlatTreeNode, expandedNodes: ExpandedNodesMap, resultList: FlatTreeNode[]) => {
      const { id, children } = node.node;
      const expanded = expandedNodes[id];

      resultList.push(node);

      if (expanded && Array.isArray(children) && children.length > 0) {
        for (const index in children) {
          collectNodeInfo(
            {
              node: children[index],
              depth: node.depth + 1,
              parentId: id,
              siblingCount: children.length,
              siblingPosition: parseInt(index) + 1,
            },
            expandedNodes,
            resultList
          );
        }
      }
    },
    []
  );

  return useMemo(() => {
    const resultList: FlatTreeNode[] = [];
    for (const index in nodes) {
      collectNodeInfo(
        {
          node: nodes[index],
          depth: 1,
          parentId: undefined,
          siblingCount: nodes.length,
          siblingPosition: parseInt(index) + 1,
        },
        expandedNodes,
        resultList
      );
    }
    return resultList;
  }, [nodes, expandedNodes, collectNodeInfo]);
}
